<template>
  <div>
    Hello there, from the Outside Open Team!<br />
    You are running the following versions of our software<br /><br />
    <b>Client</b>
    <br />
    {"branch": "{{ branch }}" "sha": "{{ sha }}", "environment": "{{ env }}" }
    <br />
    <br />
    <b>Server</b>
    <br />
    {{ server }}
  </div>
</template>
<script>
import { StatusAPI } from "@/lib/api"

export default {
  created() {
    StatusAPI.get().then(response => {
      console.log(response)
      this.server = response
    })
  },
  data() {
    return {
      server: undefined,
      branch: process.env.VUE_APP_GIT_BRANCH,
      env: process.env.NODE_ENV,
      sha: process.env.VUE_APP_GIT_SHA
    }
  }
}
</script>
